import { FC } from 'react';
import BiceVidaLogo from '@svg/bice_vida_logo.svg';
import Image from 'next/image';

type PropsI = {
  secondLogo?: {
    image: string;
    width: number;
    height: number;
  };
};

export const Header: FC<PropsI> = ({ secondLogo }) => {
  const defaults = {
    image: BiceVidaLogo,
    altImage: 'Bice Vida Welcome Cat',
  };

  const { image, width, height } = secondLogo || {};

  return (
    <div className="flex justify-end md:justify-start items-center gap-3">
      <div className="hidden md:block">
        <Image src={defaults.image} alt={defaults.altImage} />
      </div>
      {image && <Image src={image} width={width} height={height} alt="second logo" />}
    </div>
  );
};
